import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtils } from '@shared/utils';
import { RequestStrategyEnum, UsersApi, type WithSignal, type UsersRequest, type GetAccountUsersResponse } from '@shared/api';

const getAccountUsersEffect = createEffect(({ signal, ...request }: WithSignal<UsersRequest>) => UsersApi.getAccountUsers(request, signal));
const clearEvent = createEvent();

const $dataStore = createStore<GetAccountUsersResponse[]>([])
  .on(getAccountUsersEffect.done, (_, data) => data.result.data ?? [])
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getAccountUsersEffect.pending, (_, data) => data)
  .on(getAccountUsersEffect.fail, (_, data) => ApiUtils.abortApiLoadingFailCaseTrigger(data.error))
  .on(getAccountUsersEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getAccountUsersEffect, () => null)
  // .on(getAccountUsersEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getAccountUsersEffect.fail, () => 'Something went wrong while fetching Managers. Please try again.')
  .on(getAccountUsersEffect.done, () => null)
  .reset(clearEvent);

const getAccountUsersApi = ApiUtils.wrapperApi(getAccountUsersEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getAccountUsersApi.cancel());

export const $usersAccountStore = {
  events: {
    getAccountUsers: getAccountUsersApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
